import MuiBox from '@mui/material/Box';
import React from 'react';

type MuiBoxProps = {
  children: React.ReactNode;
  sx?: object;
  [key: string]: any;
};

const Box: React.FC<MuiBoxProps> = ({ children, sx, ...rest }) => {
  return (
    <MuiBox sx={sx} {...rest}>
      {children}
    </MuiBox>
  );
};

export default Box;
